import TableComponentsContainer from "../../../../../Components/Forms&Table/Tables/ReactstrapTables/TableComponents/TableComponentsContainer";

const TableComponents = () => {
  return <TableComponentsContainer />;
};

export default TableComponents;
